

// import React, { useEffect } from 'react';
// import { motion } from 'framer-motion';
// import './Location.css';
// import { useLanguage } from '../context/LanguageContext';
// import Icon from '../components/Icon';

// const useScrollReveal = (selector, options = {}) => {
//   useEffect(() => {
//     const observer = new IntersectionObserver((entries) => {
//       entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('in-view'); });
//     }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px', ...options });
//     document.querySelectorAll(selector).forEach(el => observer.observe(el));
//     return () => observer.disconnect();
//   }, [selector]);
// };

// const Location = () => {
//   const { t } = useLanguage();

//   useScrollReveal('.distance-scroll-item');
//   useScrollReveal('.travel-scroll-item');
//   useScrollReveal('.pilgrimage-plain-wrapper');
//   useScrollReveal('.map-plain-wrapper');
//   useScrollReveal('.directions-scroll-wrapper');

//   const distances = [
//     { from: t('location.distanceItems.pune.from'),         dist: t('location.distanceItems.pune.distance'),         time: t('location.distanceItems.pune.time') },
//     { from: t('location.distanceItems.saswad.from'),       dist: t('location.distanceItems.saswad.distance'),       time: t('location.distanceItems.saswad.time') },
//     { from: t('location.distanceItems.jejuri.from'),       dist: t('location.distanceItems.jejuri.distance'),       time: t('location.distanceItems.jejuri.time') },
//     { from: t('location.distanceItems.purandarFort.from'), dist: t('location.distanceItems.purandarFort.distance'), time: t('location.distanceItems.purandarFort.time') },
//   ];

//   const pilgrimPlaces = [
//     { key: 'saswad',      image: '/Assets/home/sopankaka madir saswad.jpeg' },
//     { key: 'narayanpur',  image: '/Assets/home/Narayannpur temple.jpeg' },
//     { key: 'bopgav',      image: '/Assets/home/balaji temple (1).jpeg' },
//     { key: 'ketkavale',   image: '/Assets/home/kanifnath temple.jpeg' },
//     { key: 'jejuri',      image: '/Assets/home/khandoba mandir jejuri (1).jpeg' },
//     { key: 'chaturmukha', image: '/Assets/home/chaturmukh temple.jpeg' },
//     { key: 'bhuleshwar',  image: '/Assets/home/bhuleshwar temple.jpeg' },
//     { key: 'pandeshwar',  image: '/Assets/home/pandeshwar temple.jpeg' },
//   ];
//   const pilgrimGalleryItems = [...pilgrimPlaces, ...pilgrimPlaces];

//   return (
//     <motion.div
//       className="location-page"
//       initial={{ opacity: 0, x: -20 }}
//       animate={{ opacity: 1, x: 0 }}
//       transition={{ duration: 0.5 }}
//     >

//       {/* ── CINEMATIC HERO ── */}
//       <div className="location-hero">
//         <div className="location-hero-bg" />
//         <div className="location-hero-overlay" />
//         <div className="location-hero-rays" aria-hidden="true">
//           {[1,2,3,4,5].map(i => <span key={i} className={`hero-ray hero-ray-${i}`} />)}
//         </div>
//         <div className="location-hero-content">
//           <span className="page-hero-pill">{t('nav.location')}</span>
//           <h1 className="page-hero-title">{t('templeTitle')}</h1>
//           <div className="page-hero-divider">
//             <span className="phd-line" /><span className="phd-diamond">◆</span><span className="phd-line" />
//           </div>
//         </div>
//         <div className="page-hero-bottom-line" />
//       </div>

//       <div className="container">

//         {/* 1. DISTANCE — parchment scroll */}
//         <section className="distance-section">
//           <h2 className="section-title">{t('location.distanceTitle')}</h2>
//           <div className="section-header-divider">
//             <span className="dot" /><span className="line" /><span className="dot" />
//           </div>
//           <div className="distance-grid">
//             {distances.map((item, index) => (
//               <div className="distance-scroll-item" key={index}>
//                 <div className="distance-scroll-content">
//                   <div className="distance-icon-wrap"><Icon name="location" /></div>
//                   <h3 className="distance-from notranslate">
//                     <span translate="no">{item.from}</span>
//                   </h3>
//                   <div className="parchment-divider" />
//                   <div className="distance-value" translate="no" lang="mr">{item.dist}</div>
//                   <div className="distance-time"><Icon name="clock" /> {item.time}</div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </section>

//         {/* 2. TRAVEL — parchment scroll */}
//         <section className="travel-section">
//           <h2 className="section-title">{t('location.travelOptionsTitle')}</h2>
//           <div className="section-header-divider">
//             <span className="dot" /><span className="line" /><span className="dot" />
//           </div>
//           <div className="travel-grid">
//             <div className="travel-scroll-item">
//               <div className="travel-scroll-content">
//                 <div className="travel-icon-wrap"><Icon name="train" /></div>
//                 <h3 className="travel-scroll-title">{t('location.travelCards.train.title')}</h3>
//                 <div className="parchment-divider" />
//                 <p><strong>{t('location.travelCards.train.nearestStation')}</strong></p>
//                 <p><strong>{t('location.travelCards.train.distanceFromStation')}</strong></p>
//                 <p><strong>{t('location.travelCards.train.travelTime')}</strong></p>
//                 <p className="travel-note">{t('location.travelCards.train.details')}</p>
//               </div>
//             </div>
//             <div className="travel-scroll-item">
//               <div className="travel-scroll-content">
//                 <div className="travel-icon-wrap"><Icon name="bus" /></div>
//                 <h3 className="travel-scroll-title">{t('location.travelCards.bus.title')}</h3>
//                 <div className="parchment-divider" />
//                 <p><strong>{t('location.travelCards.bus.nearestBusStand')}</strong></p>
//                 <p><strong>{t('location.travelCards.bus.msrtcAvailability')}</strong></p>
//                 <p><strong>{t('location.travelCards.bus.distanceAndTime')}</strong></p>
//                 <p className="travel-note">{t('location.travelCards.bus.details')}</p>
//               </div>
//             </div>
//             <div className="travel-scroll-item">
//               <div className="travel-scroll-content">
//                 <div className="travel-icon-wrap"><Icon name="car" /></div>
//                 <h3 className="travel-scroll-title">{t('location.travelCards.car.title')}</h3>
//                 <div className="parchment-divider" />
//                 <p><strong>{t('location.travelCards.car.fromPune')}</strong></p>
//                 <p><strong>{t('location.travelCards.car.distance')}</strong></p>
//                 <p><strong>{t('location.travelCards.car.travelTime')}</strong></p>
//                 <p className="travel-note">{t('location.travelCards.car.details')}</p>
//               </div>
//             </div>


// <div className="travel-scroll-item">
//               <div className="travel-scroll-content">
//                 <div className="travel-icon-wrap"><Icon name="car" /></div>
//                 <h3 className="travel-scroll-title">{t('location.travelCards.airoplane.title')}</h3>
//                 <div className="parchment-divider" />
//                 <p><strong>{t('location.travelCards.car.fromPuneAirport')}</strong></p>
//                 <p><strong>{t('location.travelCards.car.distanceKm')}</strong></p>
//                 <p><strong>{t('location.travelCards.car.DistanceTime')}</strong></p>
//                 <p className="travel-note">{t('location.travelCards.car.details')}</p>
//               </div>
//             </div>

//           </div>
//         </section>

//         {/* 3. PILGRIMAGE — NO scroll bg image, plain section */}
//         <section className="pilgrimage-section" id="pilgrimage">
//           <h2 className="section-title">{t('pageContent.pilgrimPlaces')}</h2>
//           <div className="section-header-divider">
//             <span className="dot" /><span className="line" /><span className="dot" />
//           </div>
//           <div className="pilgrimage-plain-wrapper">
//             <div className="places-gallery-shell">
//               <div className="places-gallery-track">
//                 {pilgrimGalleryItems.map((place, index) => (
//                   <article key={`${place.key}-${index}`} className="place-gallery-card">
//                     <div className="place-gallery-image">
//                       <img src={place.image} alt={t(`pageContent.${place.key}`)} loading="lazy" />
//                     </div>
//                     <h3 className="notranslate">
//                       <span translate="no">{t(`pageContent.${place.key}`)}</span>
//                     </h3>
//                     <p>{t(`pageContent.${place.key}Desc`)}</p>
//                     <span className="place-distance" translate="no">{t('pageContent.distanceValue.' + place.key)}</span>
//                   </article>
//                 ))}
//               </div>
//             </div>
//           </div>
//         </section>

//         {/* 4. MAP — NO scroll bg image, plain section */}
//         <section className="map-section">
//           <h2 className="section-title">{t('location.distanceTitle')}</h2>
//           <div className="section-header-divider">
//             <span className="dot" /><span className="line" /><span className="dot" />
//           </div>
//           <div className="map-plain-wrapper">
//             <div className="map-container">
//               <iframe
//                 title="मंदिर स्थान"
//                 src="https://www.google.com/maps?q=Shri%20Kalbhairavnath%20Mhaskoba%20Maharaj%20Temple%2C%20Kodit%2C%20Purandar%2C%20Pune%2C%20Maharashtra%20412108&output=embed"
//                 width="100%"
//                 height="420"
//                 style={{ border: 0, borderRadius: '12px' }}
//                 allowFullScreen=""
//                 loading="lazy"
//               ></iframe>
//             </div>
//             <p className="map-note">{t('location.mapNote')}</p>
//           </div>
//         </section>

//         {/* 5. DIRECTIONS — parchment scroll */}
//         <section className="directions-section">
//           <div className="directions-scroll-wrapper">
//             <div className="directions-scroll-content">
//               <h3 className="directions-title">{t('location.directionsTitle')}</h3>
//               <div className="parchment-divider" />
//               <p className="directions-text">{t('location.directionsText')}</p>
//               <div className="directions-buttons">
//                 {/* <button className="direction-btn">
//                   <Icon name="map" /> {t('location.getDirectionsBtn')}
//                 </button> */}

//                 <button
//   className="direction-btn"
//   onClick={() => window.open(
//     "https://www.google.com/maps?q=Shri%20Kalbhairavnath%20Mhaskoba%20Maharaj%20Temple%2C%20Kodit%2C%20Purandar%2C%20Pune%2C%20Maharashtra%20412108&output=embed",
//     "_blank"
//   )}
// >
//   <Icon name="map" /> {t('location.getDirectionsBtn')}
// </button>
//                 <button onClick={() => window.location.href = "tel:+918275270166"} className="direction-btn secondary">
//                   <Icon name="phone"  /> {t('location.callAssistance')}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </section>

//       </div>
//     </motion.div>
//   );
// };

// export default Location;





















import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import './Location.css';
import { useLanguage } from '../context/LanguageContext';
import Icon from '../components/Icon';

const useScrollReveal = (selector, options = {}) => {
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('in-view'); });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px', ...options });
    document.querySelectorAll(selector).forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, [selector]);
};

const Location = () => {
  const { t } = useLanguage();

  useScrollReveal('.distance-scroll-item');
  useScrollReveal('.travel-scroll-item');
  useScrollReveal('.pilgrimage-plain-wrapper');
  useScrollReveal('.map-plain-wrapper');
  useScrollReveal('.directions-scroll-wrapper');

  const distances = [
    { from: t('location.distanceItems.pune.from'),         dist: t('location.distanceItems.pune.distance'),         time: t('location.distanceItems.pune.time') },
    { from: t('location.distanceItems.saswad.from'),       dist: t('location.distanceItems.saswad.distance'),       time: t('location.distanceItems.saswad.time') },
    { from: t('location.distanceItems.jejuri.from'),       dist: t('location.distanceItems.jejuri.distance'),       time: t('location.distanceItems.jejuri.time') },
    { from: t('location.distanceItems.purandarFort.from'), dist: t('location.distanceItems.purandarFort.distance'), time: t('location.distanceItems.purandarFort.time') },
  ];

  const pilgrimPlaces = [
    { key: 'saswad',      image: '/Assets/home/sopankaka madir saswad.jpeg' },
    { key: 'narayanpur',  image: '/Assets/home/Narayannpur temple.jpeg' },
    { key: 'bopgav',      image: '/Assets/home/balaji temple (1).jpeg' },
    { key: 'ketkavale',   image: '/Assets/home/kanifnath temple.jpeg' },
    { key: 'jejuri',      image: '/Assets/home/khandoba mandir jejuri (1).jpeg' },
    { key: 'chaturmukha', image: '/Assets/home/chaturmukh temple.jpeg' },
    { key: 'bhuleshwar',  image: '/Assets/home/bhuleshwar temple.jpeg' },
    { key: 'pandeshwar',  image: '/Assets/home/pandeshwar temple.jpeg' },
  ];
  const pilgrimGalleryItems = [...pilgrimPlaces, ...pilgrimPlaces];

  return (
    <motion.div
      className="location-page"
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.5 }}
    >

      {/* ── CINEMATIC HERO ── */}
      <div className="location-hero">
        <div className="location-hero-bg" />
        <div className="location-hero-overlay" />
        <div className="location-hero-rays" aria-hidden="true">
          {[1,2,3,4,5].map(i => <span key={i} className={`hero-ray hero-ray-${i}`} />)}
        </div>
        <div className="location-hero-content">
          <span className="page-hero-pill">{t('nav.location')}</span>
          <h1 className="page-hero-title">{t('templeTitle')}</h1>
          <div className="page-hero-divider">
            <span className="phd-line" /><span className="phd-diamond">◆</span><span className="phd-line" />
          </div>
        </div>
        <div className="page-hero-bottom-line" />
      </div>

      <div className="container">

        {/* 1. DISTANCE — parchment scroll */}
        <section className="distance-section">
          <h2 className="section-title">{t('location.distanceTitle')}</h2>
          <div className="section-header-divider">
            <span className="dot" /><span className="line" /><span className="dot" />
          </div>
          <div className="distance-grid">
            {distances.map((item, index) => (
              <div className="distance-scroll-item" key={index}>
                <div className="distance-scroll-content">
                  <div className="distance-icon-wrap"><Icon name="location" /></div>
                  <h3 className="distance-from notranslate">
                    <span translate="no">{item.from}</span>
                  </h3>
                  <div className="parchment-divider" />
                  <div className="distance-value" translate="no" lang="mr">{item.dist}</div>
                  <div className="distance-time"><Icon name="clock" /> {item.time}</div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* 2. TRAVEL — parchment scroll (Now 4 cards) */}
        <section className="travel-section">
          <h2 className="section-title">{t('location.travelOptionsTitle')}</h2>
          <div className="section-header-divider">
            <span className="dot" /><span className="line" /><span className="dot" />
          </div>
          <div className="travel-grid">
            {/* Train */}
            <div className="travel-scroll-item">
              <div className="travel-scroll-content">
                <div className="travel-icon-wrap"><Icon name="train" /></div>
                <h3 className="travel-scroll-title">{t('location.travelCards.train.title')}</h3>
                <div className="parchment-divider" />
                <p><strong>{t('location.travelCards.train.nearestStation')}</strong></p>
                <p><strong>{t('location.travelCards.train.distanceFromStation')}</strong></p>
                <p><strong>{t('location.travelCards.train.travelTime')}</strong></p>
                <p className="travel-note">{t('location.travelCards.train.details')}</p>
              </div>
            </div>

            {/* Bus */}
            <div className="travel-scroll-item">
              <div className="travel-scroll-content">
                <div className="travel-icon-wrap"><Icon name="bus" /></div>
                <h3 className="travel-scroll-title">{t('location.travelCards.bus.title')}</h3>
                <div className="parchment-divider" />
                <p><strong>{t('location.travelCards.bus.nearestBusStand')}</strong></p>
                <p><strong>{t('location.travelCards.bus.msrtcAvailability')}</strong></p>
                <p><strong>{t('location.travelCards.bus.distanceAndTime')}</strong></p>
                <p className="travel-note">{t('location.travelCards.bus.details')}</p>
              </div>
            </div>

            {/* Car */}
            <div className="travel-scroll-item">
              <div className="travel-scroll-content">
                <div className="travel-icon-wrap"><Icon name="car" /></div>
                <h3 className="travel-scroll-title">{t('location.travelCards.car.title')}</h3>
                <div className="parchment-divider" />
                <p><strong>{t('location.travelCards.car.fromPune')}</strong></p>
                <p><strong>{t('location.travelCards.car.distance')}</strong></p>
                <p><strong>{t('location.travelCards.car.travelTime')}</strong></p>
                <p className="travel-note">{t('location.travelCards.car.details')}</p>
              </div>
            </div>

            {/* ✈️ Airport (Fixed) */}
            <div className="travel-scroll-item">
              <div className="travel-scroll-content">
                <div className="travel-icon-wrap"><Icon name="plane" /></div>
                <h3 className="travel-scroll-title">{t('location.travelCards.airoplane.title')}</h3>
                <div className="parchment-divider" />
                <p><strong>{t('location.travelCards.airoplane.fromPuneAirport')}</strong></p>
                <p><strong>{t('location.travelCards.airoplane.distanceKm')}</strong></p>
                <p><strong>{t('location.travelCards.airoplane.DistanceTime')}</strong></p>
                <p className="travel-note">{t('location.travelCards.airoplane.details')}</p>
              </div>
            </div>
          </div>
        </section>

        {/* 3. PILGRIMAGE */}
        <section className="pilgrimage-section" id="pilgrimage">
          <h2 className="section-title">{t('pageContent.pilgrimPlaces')}</h2>
          <div className="section-header-divider">
            <span className="dot" /><span className="line" /><span className="dot" />
          </div>
          <div className="pilgrimage-plain-wrapper">
            <div className="places-gallery-shell">
              <div className="places-gallery-track">
                {pilgrimGalleryItems.map((place, index) => (
                  <article key={`${place.key}-${index}`} className="place-gallery-card">
                    <div className="place-gallery-image">
                      <img src={place.image} alt={t(`pageContent.${place.key}`)} loading="lazy" />
                    </div>
                    <h3 className="notranslate">
                      <span translate="no">{t(`pageContent.${place.key}`)}</span>
                    </h3>
                    <p>{t(`pageContent.${place.key}Desc`)}</p>
                    <span className="place-distance" translate="no">
                      {t('pageContent.distanceValue.' + place.key)}
                    </span>
                  </article>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* 4. MAP */}
        <section className="map-section">
          <h2 className="section-title">{t('location.distanceTitle')}</h2>
          <div className="section-header-divider">
            <span className="dot" /><span className="line" /><span className="dot" />
          </div>
          <div className="map-plain-wrapper">
            <div className="map-container">
              <iframe
                title="मंदिर स्थान"
                src="https://www.google.com/maps?q=Shri%20Kalbhairavnath%20Mhaskoba%20Maharaj%20Temple%2C%20Kodit%2C%20Purandar%2C%20Pune%2C%20Maharashtra%20412108&output=embed"
                width="100%"
                height="420"
                style={{ border: 0, borderRadius: '12px' }}
                allowFullScreen=""
                loading="lazy"
              ></iframe>
            </div>
            <p className="map-note">{t('location.mapNote')}</p>
          </div>
        </section>

        {/* 5. DIRECTIONS */}
        <section className="directions-section">
          <div className="directions-scroll-wrapper">
            <div className="directions-scroll-content">
              <h3 className="directions-title">{t('location.directionsTitle')}</h3>
              <div className="parchment-divider" />
              <p className="directions-text">{t('location.directionsText')}</p>
              <div className="directions-buttons">
                <button
                  className="direction-btn"
                  onClick={() => window.open(
                    "https://maps.app.goo.gl/ygR4Wugy4ud9RCPF8",
                    "_blank"
                  )}
                >
                  <Icon name="map" /> {t('location.getDirectionsBtn')}
                </button>
                <button 
                  onClick={() => window.location.href = "tel:+918275270166"} 
                  className="direction-btn secondary"
                >
                  <Icon name="phone" /> {t('location.callAssistance')}
                </button>
              </div>
            </div>
          </div>
        </section>

      </div>
    </motion.div>
  );
};

export default Location;